import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/economy-sets`

export async function getAll() {
  return getWithRedirect(URL)
}

export async function update(id: string, name: string) {
  return axios.patch(
    `${URL}/${id}`,
    { data: { name } },
    parseAuthenticationHeader()
  )
}

export async function create(
  name: string,
  csvFile: Blob | null,
  companyIds?: string[]
) {
  const formData = new FormData()

  // Without a file the chart of accounts is created empty.
  if (csvFile) {
    formData.append('file', csvFile)
  }

  formData.append('name', name)

  // The brackets make the API read the field as a list, even with one company.
  companyIds?.forEach((id) => formData.append('company_ids[]', id))

  return axios.post(URL, formData, parseAuthenticationHeader())
}

export async function duplicate(
  id: string,
  name: string,
  includeAccountReferences: boolean,
  companyIds?: string[]
) {
  return axios.post(
    `${URL}/${id}/duplicate`,
    {
      data: {
        name,
        include_account_references: includeAccountReferences,
        company_ids: companyIds
      }
    },
    parseAuthenticationHeader()
  )
}

export async function upload(id: string, csvFile: Blob) {
  const formData = new FormData()

  formData.append('file', csvFile)

  return axios.put(
    `${URL}/${id}/economy-accounts`,
    formData,
    parseAuthenticationHeader()
  )
}

export async function updateCompanies(id: string, companyIds: string[]) {
  return axios.put(
    `${URL}/${id}/companies`,
    { data: { company_ids: companyIds } },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
